import {ComboBoxControl, FlexGap, StackHorizontal} from "@twigsby/frontend-framework";
import {useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";
import {IncludeExclude} from "../Components/IncludeExclude";

type SenderConditionType = {
    name: string;
    defaultValue: any;
    defaultIncludesValue: boolean;
    changeCallback: (value: any) => void;
}

const SenderCondition = (props: SenderConditionType) => {
    const { getValues, setValue} = useFormContext();

    return (
        <StackHorizontal gap={FlexGap.ExtraSmall}>
            <IncludeExclude name={`${props.name}.includes`} defaultValue={props.defaultIncludesValue} />

            <ComboBoxControl
                name={`${props.name}.values`}
                placeholder={'Select Sender...'}
                valueType={'number'}
                data={[]}
                defaultValues={getValues(props.name).value ? [getValues(props.name).value] : undefined}
                singleSelection={true}
                forwardValueCallback={(e) => setValue(props.name, e)}
            />
        </StackHorizontal>
    )
}

export { SenderCondition }
